<script>
export default {
  name: 'LogoHeader',
};
</script>

<template>
  <div class="row">
    <img src="@/assets/lr-logo.png" alt="Logo" fluid width="40px" height="40px" />
    <h3 class="align-content-center mt-1 ml-3">Lunch Roulette</h3>
  </div>
</template>
